import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const LocationService = {};

LocationService.getLocations = function (params) {
  return fetch({
    url: ApiConstant.LOCATION_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
LocationService.downalodLocationExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.LOCATION_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
LocationService.statusUpdateLocation = function (data, status) {
  const payload = {
    status: status,
    delivery_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.LOCATION_BULK_STATUS_UPDATE,
    method: "put",
    data: payload,
  });
};

LocationService.addLocation = function (data, params) {
  return fetch({
    url: ApiConstant.LOCATION_CREATE,
    method: "post",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
LocationService.getSingleLocation = function (params) {
  return fetch({
    url: ApiConstant.LOCATION_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

LocationService.updateLocation = function (params, data) {
  return fetch({
    url: ApiConstant.LOCATION_UPDATE,
    method: "PUT",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
export default LocationService;
